export default __webpack_public_path__ + "static/media/profile.1bf9038d.svg";